import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { createInstagramCommunicationsSlice } from './actions';
import { InstagramCommunicationsStore } from './types';
import { ZustandStores } from '../../utils';
import { createIndexedDBStorage } from '../../utils/indexedDBAdapter';

export const useInstagramCommunicationsStore =
  create<InstagramCommunicationsStore>()(
    persist(
      (set, get, store) => ({
        ...createInstagramCommunicationsSlice(set, get, store),
      }),
      {
        name: ZustandStores.INSTAGRAM_COMMUNICATIONS,
        storage: createJSONStorage(() => createIndexedDBStorage()),
        partialize: ({ conversations }) => ({ conversations }),
      },
    ),
  );
